$(document).ready(function () {
    initStatistics();
});

function initStatistics() {
    let block = $('[data-statistics]');
    if (block.length === 0) {
        return;
    }

    initCellsUsage();
    initCellsStats();
    initCellsSizesStats();

    initCellsUsagePie();
    initCellsStatsPie();
}

function initCellsUsage() {
    let action = 'cells_usage';
    let block = $('[data-statistics="' + action + '"]');
    if (block.length === 0) {
        return;
    }

    $('[name="devices"]', block).select2({
        placeholder: _('All'),
        allowClear: true
    });
    $('.input-daterange', block).datepicker({
        language: $('html').attr('lang'),
        todayHighlight: true
    });

    block.on('change', '[name="devices"], [name="start"], [name="end"]', function () {
        getStatistics('table', action, block);
    });

    getStatistics('table', action, block);
}

function initCellsStats() {
    let action = 'cells_stats';
    let block = $('[data-statistics="' + action + '"]');
    if (block.length === 0) {
        return;
    }

    $('[name="devices"]', block).select2({
        placeholder: _('All'),
        allowClear: true
    });

    block.on('change', '[name="devices"]', function () {
        getStatistics('table', action, block);
    });

    getStatistics('table', action, block);
}

function initCellsSizesStats() {
    let action = 'cells_sizes_stats';
    let block = $('[data-statistics="' + action + '"]');
    if (block.length === 0) {
        return;
    }

    $('[name="devices"]', block).select2({
        placeholder: _('All'),
        allowClear: true
    });

    block.on('change', '[name="devices"]', function () {
        getStatistics('table', action, block);
    });

    getStatistics('table', action, block);
}

function initCellsUsagePie() {
    let action = 'cells_usage';
    let block = $('[data-statistics-pie="' + action + '"]');
    if (block.length === 0) {
        return;
    }

    $('[name="devices"]', block).select2({
        placeholder: _('All'),
        allowClear: true
    });
    $('.input-daterange', block).datepicker({
        language: $('html').attr('lang'),
        todayHighlight: true
    });

    block.on('change', '[name="devices"], [name="start"], [name="end"]', function () {
        getStatistics('pie', action, block);
    });

    getStatistics('pie', action, block);
}

function initCellsStatsPie() {
    let action = 'cells_stats';
    let block = $('[data-statistics-pie="' + action + '"]');
    if (block.length === 0) {
        return;
    }

    $('[name="devices"]', block).select2({
        placeholder: _('All'),
        allowClear: true
    });

    block.on('change', '[name="devices"]', function () {
        getStatistics('pie', action, block);
    });

    getStatistics('pie', action, block);
}

function getStatistics(type, action, block) {
    let url = '/statistics/';
    let data = {
        action: action,
        device: $('[data-device]').data('device'),
        devices: $('[name="devices"]', block).val(),
        start: $('[name="start"]', block).val(),
        end: $('[name="end"]', block).val()
    };
    sendPost(url, data, function (response) {
        if (type === 'table') {
            if (action === 'cells_sizes_stats') {
                updateStatisticsTableSizes(action, block, response);
            } else {
                updateStatisticsTable(action, block, response);
            }
        } else if (type === 'pie') {
            updateStatisticsPie(action, block, response);
        }
    });
}

function updateStatisticsPie(action, block, response) {
    $('.card-body', block).empty().append($('<div/>').attr('id', action + '-pie'));
    Highcharts.chart(action + '-pie', {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
        },
        title: null,
        tooltip: {
            pointFormat: '<b>{point.count}</b> ({point.percentage:.1f}%)'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        legend: {
            itemMarginTop: 2,
            itemMarginBottom: 2
        },
        plotOptions: {
            pie: {
                cursor: 'pointer',
                dataLabels: {
                    enabled: false
                },
                showInLegend: true
            }
        },
        series: getPieSeries(action, response)
    });
}

function getPieSeries(action, response) {
    let series = [];

    if (action === 'cells_stats') {
        let total = response.data.rows.sum.total;
        let free = response.data.rows.sum.free;
        let occupied = total - free;
        series = [{
            colorByPoint: true,
            data: [{
                name: _('Free'),
                count: free,
                y: parseFloat(((free / total) * 100).toFixed(2))
            }, {
                name: _('Occupied'),
                count: occupied,
                y: parseFloat(((occupied / total) * 100).toFixed(2))
            }]
        }];
    } else if (action === 'cells_usage') {
        let reserved = response.data.rows.sum.reserved;
        let placed = response.data.rows.sum.placed;
        let recipient_withdrawn = response.data.rows.sum.recipient_withdrawn;
        let withdrawal_prepared = response.data.rows.sum.withdrawal_prepared;
        let service_withdrawn = response.data.rows.sum.service_withdrawn;
        let canceled = response.data.rows.sum.canceled;
        let total = reserved + placed + recipient_withdrawn + withdrawal_prepared + service_withdrawn + canceled
        series = [{
            colorByPoint: true,
            data: [{
                name: response.data.row_names.reserved,
                count: reserved,
                y: parseFloat(((reserved / total) * 100).toFixed(2))
            }, {
                name: response.data.row_names.placed,
                count: placed,
                y: parseFloat(((placed / total) * 100).toFixed(2))
            }, {
                name: response.data.row_names.recipient_withdrawn,
                count: recipient_withdrawn,
                y: parseFloat(((recipient_withdrawn / total) * 100).toFixed(2))
            }, {
                name: response.data.row_names.withdrawal_prepared,
                count: withdrawal_prepared,
                y: parseFloat(((withdrawal_prepared / total) * 100).toFixed(2))
            }, {
                name: response.data.row_names.service_withdrawn,
                count: service_withdrawn,
                y: parseFloat(((service_withdrawn / total) * 100).toFixed(2))
            }, {
                name: response.data.row_names.canceled,
                count: canceled,
                y: parseFloat(((canceled / total) * 100).toFixed(2))
            }]
        }];
    }

    return series;
}

function updateStatisticsTable(action, block, response) {
    $('.table-left thead', block).empty().append($('<tr/>').append($('<th/>').html('&nbsp;')));
    $('.table-left tbody', block).empty();

    $('.table-right thead', block).empty().append($('<tr/>'));
    $('.table-right tbody', block).empty();
    for (let col_name in response.data.col_names) {
        $('.table-right thead tr', block).append($('<th/>').html(response.data.col_names[col_name]));
    }
    for (let row_name in response.data.row_names) {
        $('.table-left tbody', block).append($('<tr/>').append($('<th/>').html(response.data.row_names[row_name])))
        let tr = $('<tr/>');
        for (let col_name in response.data.col_names) {
            tr.append($('<td/>').html(response.data.rows[col_name][row_name]))
        }
        $('.table-right tbody', block).append(tr);
    }
}

function updateStatisticsTableSizes(action, block, response) {
    let hide_type = block.data('hide-type');

    $('.table-left thead', block).empty();
    $('.table-left tbody', block).empty();

    let tr = $('<tr/>');
    tr.append($('<th/>').text(response.data.name));
    for (let col in response.data.row_names) {
        if (col === 'type_id' && hide_type) {
            continue;
        }
        tr.append($('<th/>').text(response.data.row_names[col]));
    }
    $('.table-left thead', block).append(tr);

    for (let index in response.data.col_names) {
        for (let col_name in response.data.col_names[index]) {
            let tr = $('<tr/>');
            tr.append($('<th/>').text(col_name));
            for (let index in response.data.rows) {
                if (response.data.rows[index][col_name]) {
                    for (let col in response.data.rows[index][col_name]) {
                        if (col === 'type_id' && hide_type) {
                            continue;
                        }
                        tr.append($('<td/>').text(response.data.rows[index][col_name][col]));
                    }
                    delete response.data.rows[index];
                    break;
                }
            }
            $('.table-left tbody', block).append(tr);
        }
    }
}